var _a, _b, _c, _d, _e;
import { EActionState, createCustomAction } from "../utils/action.utils";
import { GENERATOR_PARAMS } from "./preference.constants";
var EActionCustom;
(function (EActionCustom) {
    EActionCustom["GetPreference"] = "GET_PREFERENCE";
    EActionCustom["CreatePreference"] = "CREATE_PREFERENCE";
    EActionCustom["UpdatePreference"] = "UPDATE_PREFERENCE";
    EActionCustom["GetExtraChecklistConfig"] = "GET_EXTRA_CHECKLIST_CONFIG";
    EActionCustom["UpdateExtraChecklistConfig"] = "UPDATE_EXTRA_CHECKLIST_CONFIG";
})(EActionCustom || (EActionCustom = {}));
var generateGetPreferenceActions = function () { return ({
    getPreferencesStart: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.GetPreference,
        state: EActionState.Start,
    }),
    getPreferenceSucceeded: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.GetPreference,
        state: EActionState.Success,
    }),
    getPreferenceFailed: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.GetPreference,
        state: EActionState.Fail,
    }),
}); };
var generateCreatePreferenceActions = function () { return ({
    createPreferenceStart: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.CreatePreference,
        state: EActionState.Start,
    }),
    createPreferenceSucceeded: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.CreatePreference,
        state: EActionState.Success,
    }),
    createPreferenceFailed: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.CreatePreference,
        state: EActionState.Fail,
    }),
}); };
var generateUpdatePreferenceActions = function () { return ({
    updatePreferenceStart: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.UpdatePreference,
        state: EActionState.Start,
    }),
    updatePreferenceSucceeded: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.UpdatePreference,
        state: EActionState.Success,
    }),
    updatePreferenceFailed: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.UpdatePreference,
        state: EActionState.Fail,
    }),
}); };
var generateGetExtraChecklistConfigActions = function () { return ({
    getExtraChecklistConfigStart: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.GetExtraChecklistConfig,
        state: EActionState.Start,
    }),
    getExtraChecklistConfigSucceeded: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.GetExtraChecklistConfig,
        state: EActionState.Success,
    }),
    getExtraChecklistConfigFailed: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.GetExtraChecklistConfig,
        state: EActionState.Fail,
    }),
}); };
var generateUpdateExtraChecklistConfigActions = function () { return ({
    updateExtraChecklistConfigStart: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.UpdateExtraChecklistConfig,
        state: EActionState.Start,
    }),
    updateExtraChecklistConfigSucceeded: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.UpdateExtraChecklistConfig,
        state: EActionState.Success,
    }),
    updateExtraChecklistConfigFailed: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.UpdateExtraChecklistConfig,
        state: EActionState.Fail,
    }),
}); };
export var getPreferencesStart = (_a = generateGetPreferenceActions(), _a.getPreferencesStart), getPreferenceSucceeded = _a.getPreferenceSucceeded, getPreferenceFailed = _a.getPreferenceFailed;
export var createPreferenceStart = (_b = generateCreatePreferenceActions(), _b.createPreferenceStart), createPreferenceSucceeded = _b.createPreferenceSucceeded, createPreferenceFailed = _b.createPreferenceFailed;
export var updatePreferenceStart = (_c = generateUpdatePreferenceActions(), _c.updatePreferenceStart), updatePreferenceSucceeded = _c.updatePreferenceSucceeded, updatePreferenceFailed = _c.updatePreferenceFailed;
export var getExtraChecklistConfigStart = (_d = generateGetExtraChecklistConfigActions(), _d.getExtraChecklistConfigStart), getExtraChecklistConfigSucceeded = _d.getExtraChecklistConfigSucceeded, getExtraChecklistConfigFailed = _d.getExtraChecklistConfigFailed;
export var updateExtraChecklistConfigStart = (_e = generateUpdateExtraChecklistConfigActions(), _e.updateExtraChecklistConfigStart), updateExtraChecklistConfigSucceeded = _e.updateExtraChecklistConfigSucceeded, updateExtraChecklistConfigFailed = _e.updateExtraChecklistConfigFailed;
